module.exports = __webpack_public_path__ + "static/apple-a48e300fbc3e1f7f45bb70f4aba9baa4.svg";